import React from 'react';

const POPreview = ({ order, onClose }) => {
  if (!order) return null;

  const items = order.items || [];
  const totalQuantity = items.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0);

  const getProductTypeLabel = (type) => {
    switch (type) {
      case 'battery': return 'แบตเตอรี่';
      case 'charger': return 'ชาร์จเจอร์';
      case 'accessory': return 'อุปกรณ์เสริม';
      default: return type;
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const downloadPDF = () => {
    // Open preview in new window and use html2pdf
    const previewWindow = window.open('', '_blank', 'width=800,height=600');

    if (!previewWindow) {
      alert('ไม่สามารถเปิดหน้าต่างได้ กรุณาอนุญาต popup');
      return;
    }

    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>ใบสั่งซื้อ ${order.po_number}</title>
      <meta charset="utf-8">
      <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Sarabun', 'Segoe UI', Tahoma, sans-serif; 
          font-size: 14px; 
          background: #f5f5f5;
          padding: 20px;
        }
        .page {
          background: white;
          width: 210mm;
          min-height: 297mm;
          padding: 15mm;
          margin: 0 auto 20px;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 3px solid #0066cc;
          padding-bottom: 15px;
          margin-bottom: 20px;
        }
        .company-info h2 { color: #0066cc; margin-bottom: 5px; font-size: 18px; }
        .company-info p { font-size: 12px; color: #666; margin: 2px 0; }
        .document-title {
          background: linear-gradient(135deg, #0066cc 0%, #004499 100%);
          color: white;
          padding: 12px 25px;
          border-radius: 8px;
          text-align: center;
        }
        .document-title h1 { font-size: 20px; margin-bottom: 5px; }
        .document-title .po-number { font-size: 14px; opacity: 0.9; }
        
        .info-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          padding: 15px;
        }
        .info-group label { 
          font-weight: bold; 
          color: #333; 
          display: block;
          margin-bottom: 3px;
          font-size: 12px;
        }
        .info-group span { color: #000; font-size: 14px; }
        
        .items-section { margin-bottom: 20px; }
        .section-title {
          background: #0066cc;
          color: white;
          padding: 10px 15px;
          border-radius: 8px 8px 0 0;
          font-weight: bold;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #e0e0e0;
        }
        th {
          background: #f0f0f0;
          padding: 12px 10px;
          text-align: center;
          font-weight: bold;
          color: #333;
          border: 1px solid #e0e0e0;
          font-size: 13px;
        }
        td {
          padding: 10px;
          border: 1px solid #e0e0e0;
          font-size: 13px;
        }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        
        .total-row {
          background: #f8f9fa;
          font-weight: bold;
        }
        .total-row td { border-top: 2px solid #0066cc; }
        
        .footer-section {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px dashed #ccc;
        }
        .signature-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 50px;
          margin-top: 60px;
        }
        .signature-box {
          text-align: center;
        }
        .signature-line {
          border-top: 1px solid #000;
          width: 200px;
          margin: 0 auto 10px;
        }
        .signature-label { font-size: 12px; color: #666; }
        
        .notes-section {
          margin-top: 20px;
          padding: 15px;
          background: #f8f9fa;
          border-radius: 8px;
          border-left: 4px solid #0066cc;
        }
        .notes-section h4 { color: #0066cc; margin-bottom: 5px; font-size: 14px; }
        .notes-section p { font-size: 13px; color: #333; }
        
        .status-badge {
          display: inline-block;
          padding: 5px 15px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: bold;
        }
        .status-pending { background: #17a2b8; color: white; }
        .status-ordering { background: #ffc107; color: #333; }
        .status-shipping { background: #007bff; color: white; }
        .status-arrived { background: #6c757d; color: white; }
        .status-received { background: #28a745; color: white; }
        
        .action-buttons {
          position: fixed;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 12px;
          background: white;
          padding: 12px 25px;
          border-radius: 50px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
          z-index: 1000;
        }
        .btn {
          padding: 10px 24px;
          border: none;
          border-radius: 25px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          transition: all 0.2s;
        }
        .btn-print {
          background: #fff;
          color: #333;
          border: 1px solid #e0e0e0;
        }
        .btn-print:hover { background: #f0f0f0; }
        .btn-download {
          background: linear-gradient(135deg, #0066cc 0%, #004499 100%);
          color: white;
        }
        .btn-download:hover { transform: translateY(-2px); box-shadow: 0 4px 15px rgba(0,102,204,0.4); }
        .btn-close {
          background: #fff;
          color: #dc3545;
          border: 1px solid #ffd7d7;
        }
        .btn-close:hover { background: #fff5f5; }
        
        @media print {
          body { background: white; padding: 0; }
          .page { 
            box-shadow: none; 
            margin: 0; 
            padding: 10mm;
            page-break-after: always;
          }
          .action-buttons { display: none !important; }
        }
      </style>
    </head>
    <body>
      <div id="po-content">
        <div class="page">
          <div class="header">
            <div class="company-info">
              <h2>บริษัท เค.ทีแพน จำกัด (สำนักงานใหญ่)</h2>
              <p>K.T.PAN CO., LTD.</p>
              <p>1408 9-10 ถนนพหลโยธิน แขวงจอมพล เขตจตุจักร กรุงเทพมหานคร 10900</p>
              <p>โทร: 02-939-3147</p>
              <p>เลขประจำตัวผู้เสียภาษี: 0105531018001</p>
            </div>
            <div class="document-title">
              <h1>ใบสั่งซื้อ</h1>
              <div class="po-number">${order.po_number}</div>
            </div>
          </div>
          
          <div class="info-section">
            <div class="info-group">
              <label>ผู้จำหน่าย / Supplier</label>
              <span>${order.supplier}</span>
            </div>
            <div class="info-group">
              <label>สถานะ</label>
              <span class="status-badge ${getStatusClass(order.status)}">${order.status}</span>
            </div>
            <div class="info-group">
              <label>วันที่สั่งซื้อ</label>
              <span>${formatDate(order.order_date)}</span>
            </div>
            <div class="info-group">
              <label>วันที่คาดว่าจะได้รับ</label>
              <span>${formatDate(order.expected_date)}</span>
            </div>
            <div class="info-group">
              <label>ผู้สร้างรายการ</label>
              <span>${order.created_by_name || '-'}</span>
            </div>
            <div class="info-group">
              <label>วันที่สร้าง</label>
              <span>${formatDate(order.created_at)}</span>
            </div>
          </div>
          
          <div class="items-section">
            <div class="section-title">รายการสินค้าที่สั่งซื้อ</div>
            <table>
              <thead>
                <tr>
                  <th width="8%">ลำดับ</th>
                  <th width="15%">ประเภท</th>
                  <th width="25%">ยี่ห้อ</th>
                  <th width="32%">รุ่น/โมเดล</th>
                  <th width="20%">จำนวน</th>
                </tr>
              </thead>
              <tbody>
                ${items.map((item, index) => `
                  <tr>
                    <td class="text-center">${index + 1}</td>
                    <td class="text-center">${getProductTypeLabel(item.productType)}</td>
                    <td>${item.brand}</td>
                    <td>${item.model}</td>
                    <td class="text-center">${item.quantity}</td>
                  </tr>
                `).join('')}
                <tr class="total-row">
                  <td colspan="4" class="text-right">รวมจำนวนทั้งหมด</td>
                  <td class="text-center">${totalQuantity}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          ${order.note ? `
            <div class="notes-section">
              <h4>หมายเหตุ</h4>
              <p>${order.note}</p>
            </div>
          ` : ''}
          
          <div class="footer-section">
            <div class="signature-grid">
              <div class="signature-box">
                <div class="signature-line"></div>
                <div class="signature-label">ผู้สั่งซื้อ</div>
              </div>
              <div class="signature-box">
                <div class="signature-line"></div>
                <div class="signature-label">ผู้อนุมัติ</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="action-buttons" data-html2canvas-ignore="true">
        <button onclick="window.print()" class="btn btn-print">
          <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z" /></svg>
          พิมพ์
        </button>
        <button onclick="downloadPDF()" class="btn btn-download">
          <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" /></svg>
          ดาวน์โหลด PDF
        </button>
        <button onclick="window.close()" class="btn btn-close">
          <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>
          ปิด
        </button>
      </div>
      
      <script>
        function getProductTypeLabel(type) {
          switch(type) {
            case 'battery': return 'แบตเตอรี่';
            case 'charger': return 'ชาร์จเจอร์';
            case 'accessory': return 'อุปกรณ์เสริม';
            default: return type;
          }
        }
        
        function getStatusClass(status) {
          switch(status) {
            case 'ส่งออเดอร์แล้ว': return 'status-pending';
            case 'กำลังสั่งซื้อ': return 'status-ordering';
            case 'จัดส่ง': return 'status-shipping';
            case 'ถึงคลัง': return 'status-arrived';
            case 'รับเข้าแล้ว': return 'status-received';
            default: return '';
          }
        }
        
        function downloadPDF() {
          const element = document.getElementById('po-content');
          const opt = {
            margin: 0,
            filename: '${order.po_number}.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
          };
          
          html2pdf().set(opt).from(element).save();
        }
      </script>
    </body>
    </html>
    `;

    previewWindow.document.write(htmlContent);
    previewWindow.document.close();
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'ส่งออเดอร์แล้ว': return 'status-pending';
      case 'กำลังสั่งซื้อ': return 'status-ordering';
      case 'จัดส่ง': return 'status-shipping';
      case 'ถึงคลัง': return 'status-arrived';
      case 'รับเข้าแล้ว': return 'status-received';
      default: return '';
    }
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: '85vw', width: '85vw' }}>
        <div className="modal-content" style={{ width: '100%', maxWidth: 'none' }}>
          <div className="modal-header" style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #0052a3 100%)', color: 'white' }}>
            <h5 className="modal-title thai-text">
              <i className="fas fa-file-alt me-2"></i>
              ใบสั่งซื้อ {order.po_number}
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
            {/* Info Section */}
            <div className="row mb-4">
              <div className="col-md-6">
                <p><strong>ผู้จำหน่าย:</strong> {order.supplier}</p>
                <p><strong>วันที่สั่ง:</strong> {formatDate(order.order_date)}</p>
                <p><strong>วันที่คาดว่าได้รับ:</strong> {formatDate(order.expected_date)}</p>
              </div>
              <div className="col-md-6">
                <p><strong>สถานะ:</strong> <span className={`badge bg-${order.status === 'รับเข้าแล้ว' ? 'success' : 'info'}`}>{order.status}</span></p>
                <p><strong>ผู้สร้าง:</strong> {order.created_by_name || '-'}</p>
              </div>
            </div>

            {/* Items Table */}
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="table-dark">
                  <tr>
                    <th className="text-center" style={{ width: '60px' }}>#</th>
                    <th className="thai-text">ประเภท</th>
                    <th className="thai-text">ยี่ห้อ</th>
                    <th className="thai-text">รุ่น/โมเดล</th>
                    <th className="text-center thai-text" style={{ width: '100px' }}>จำนวน</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{getProductTypeLabel(item.productType)}</td>
                      <td>{item.brand}</td>
                      <td>{item.model}</td>
                      <td className="text-center">{item.quantity}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="table-light">
                  <tr>
                    <td colSpan="4" className="text-end fw-bold">รวมจำนวนทั้งหมด:</td>
                    <td className="text-center fw-bold">{totalQuantity}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {order.note && (
              <div className="alert alert-secondary">
                <strong>หมายเหตุ:</strong> {order.note}
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              <i className="fas fa-times me-1"></i>
              ปิด
            </button>
            <button type="button" className="btn btn-primary" onClick={downloadPDF}>
              <i className="fas fa-file-pdf me-1"></i>
              ดาวน์โหลด PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default POPreview;
